$(globalThis).on("load", function () {
  const textForHeaderSignUp = "Enter Your Email and Get 2 for 1 Admission!";
  const textForCountdown = "Sending you to the next page in ";
  const pageToBeRedirected = "https://memphisboatshow.saffire.com/p/extra/bogo-admission";
  const timeOutValue = 5;

  let submitEmail = $(".signup-container .emailSignup .inputFieldSubmit");
  let inputEmail = $(".signup-container .emailSignup input");

  $(".signup-container .emailSignup .emailSignupText").remove();
  $(".signup-container .emailSignup .emailInputField").prepend(`
    <div id="coupon-box">
      <h2>${textForHeaderSignUp}</h2>
    </div>
  `);

  $(".signup-container .emailSignup .emailInputSubmit .inputFieldSubmit").text("Submit");

  // Input email enter event
  $(inputEmail).keydown(function (event) {
    if (event.key == "Enter") {
      submitForm();
    }
  });

  // Click event
  $(submitEmail).on("keypress click", function (event) {
    if (event.key == "Enter" || event.type == "click") {
      submitForm();
    }
  });

  // Launch ticket function
  function submitForm() {
    let validationInProgress = true;
    setTimeout(function () {
      validationInProgress = false;
    }, 2000);

    let validationInterval = setInterval(function () {
      if (!validationInProgress) {
        clearInterval(validationInterval);
        return;
      }

      if ($("body").hasClass("hideBackToTop")) {
        clearInterval(validationInterval);
        $("body").append(
          `<div class="coupon-opening">
            ${textForCountdown} <span id="seconds">${timeOutValue}</span> seconds...
          </div>`
        );
        countdown(timeOutValue - 1);
        setTimeout(() => {
          actionAfterCountdonEnds();
        }, 3000);
      }
    }, 100);
  }

  // Action to be triggered when countdown ends
  function actionAfterCountdonEnds() {
    parent.location.href = pageToBeRedirected;
  }

  // Countdown
  function countdown(seconds) {
    const countdownDiv = document.getElementById("seconds");
    let timer = setInterval(() => {
      countdownDiv.textContent = seconds;
      seconds--;
      if (seconds < 0) {
        clearInterval(timer);
      }
    }, 1000);
  }
});

$(globalThis).load(function () {
  const movedSignUp = $("#signup-tickets");
  const signUpContainer = $(".signup-container");

  if ($(movedSignUp).length) {
    movedSignUp.append(signUpContainer);
  } else {
    $(signUpContainer).remove();
  }
});